module.exports = __webpack_public_path__ + "media/assets/images/events/laura-interview-3004f49b9562102e934b597aca8c8b3f.png";